import React, { useEffect, useState,useImperativeHandle,forwardRef } from 'react';
import {Card,List,Form,Row,Col,InputNumber,message,Divider} from 'antd';

const QualityList = forwardRef(({form},ref)=>{
  const [data,setData] = useState([]);
  useImperativeHandle(ref, () => ({
    data,
    setData,
    setCount
  }));
  const [count,setCount] = useState(0);
  useEffect(() => {
    let newCount = count + 1;
    setCount(newCount);
    setData(prevData => [
      ...prevData,
      {
        key: newCount,
        lower:0,
        high:'',
        rate:''
      }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAdd = () => {
    const highestKey = Math.max(...data.map(item => item.key));
    const find = data.find(item => item.key === highestKey);
    const newCount = highestKey + 1;

    if (!form.getFieldValue(`high[${highestKey}]`)) {
      return message.error('请输入数值');
    }

    if (+find?.high < +find?.lower) {
      return message.error('到货数量需大于X左边的数值且整数');
    }
    setData(preData=>[
      ...preData,
      {
        key: newCount,
        lower: find?.high || 0,
        high:'',
        rate:''
      },
    ]);
    setCount(newCount);
  };


  const addonBeforeLower = (item={}) => {
     return (
      <div>
        {`${item?.lower ?? ''} < X <=`}
      </div>
     );
  };

  const handleQualityDelete = (item = {}) => {
    const newData = data.filter(dataItem => dataItem.key !== item.key);
    if (newData.length > 0) {
      newData[0].lower = 0;
      newData.map((dataItem, index) => {
        if (index > 0) {
          dataItem.lower = newData[index - 1].high;
        }
        return dataItem;
      });
    }
    setData(newData);
    form.setFieldsValue({
      [`high[${item.key}]`]: '',
      [`rate[${item.key}]`]: '',
    });

    setCount(prevCount => prevCount - 1);
  };

  return (
    <Card>
      <div style={{display:'flex',justifyContent:'space-around',}}>
        <span>到货数量（X）</span>
        <span>抽检比例</span>
        <span style={{color:'#1e80ff',cursor:'pointer'}} onClick={handleAdd}>新增</span>
      </div>
      <Divider/>
      <List
        itemLayout="vertical"
        size="large"
        dataSource={data}
        renderItem={(item,index) => (
          <List.Item
            key={item.title}
          >
            <div>
              <Row gutter={24}>
                <Col span={9}>
                <Form.Item
                name={`high[${item.key}]`}
                validateFirst={true}
                rules={[
                  {
                    required:true,
                    message:'请输入数值'
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const numberRegex = /^[1-9]\d*$/; // 正则表达式，表示大于0的整数
                        if (!numberRegex.test(value)) {
                          return Promise.reject('请输入大于0的整数');
                        }
                        if(+value <= +item.lower ){
                          return Promise.reject('到货数量需大于X左边的数值且整数');
                        }
                        return Promise.resolve();
                    },
                  }),
                ]}
                >
                  <InputNumber value={item.high}  onChange={(e)=>{
                    item.high = e;
                  }}  addonBefore={addonBeforeLower(item)} placeholder='数值' disabled={data.length-1 !== index }/>
                </Form.Item>
                </Col>
                <Col span={9}>
                <Form.Item
                name={`rate[${item.key}]`}
                 validateFirst={true}
                 rules={[
                   {
                     required:true,
                     message:'请输入比值'
                   },
                   ({ getFieldValue }) => ({
                    validator(_, value) {
                      const numberRegex = /^[1-9]\d*$/; // 正则表达式，表示大于0的整数
                        if (!numberRegex.test(value)) {
                          return Promise.reject('请输入大于0的整数');
                        }

                        return Promise.resolve();

                    },
                  }),
                 ]}
                >
                <InputNumber
                min={1}
                max={100}
                addonAfter='%'
                placeholder='比值'
                value={item.rate}
                onChange={(e)=>{
                  item.rate = e;
                }}
                 />
                </Form.Item>
                </Col>
                <Col span={6}>
                <Form.Item style={{textAlign:'center'}}>
                  {
                    data.length === 1 ? '': <a onClick={()=>handleQualityDelete(item)}>删除</a>
                  }
                </Form.Item>
                </Col>
              </Row>
            </div>
          </List.Item>
        )}
      />
    </Card>
  );
});

export default QualityList;